import { Link } from "@inertiajs/react";
import { SectionShell } from "@/components/design-system/SectionShell";
import { Button } from "@/components/ui/button";

const code = `import { Button } from "@/components/ui/button";

<Button asChild variant="gold" size="lg">
  <Link href="/contact">Request a Consultation</Link>
</Button>
<Button asChild variant="ghost-hairline" size="lg">
  <Link href="/wines">View Our Wines</Link>
</Button>

<Button asChild variant="gold" size="sm">
  <Link href="/contact">Request a Consultation</Link>
</Button>`;

export function PublicButtonsSection() {
  return (
    <SectionShell
      id="buttons-public"
      title="Buttons — public"
      description={
        <>
          The public site's buttons, from the Private Cellar mockup: square,
          uppercase, letter-spaced. <code>gold</code> is the gold-gradient
          primary; <code>ghost-hairline</code> is the hairline secondary. With
          these variants <code>size="sm"</code> and <code>size="lg"</code> map
          to the mockup's small (header) and large (hero, bands) metrics — the
          admin sizes are unchanged.
        </>
      }
      whenToUse={
        <ul>
          <li>
            Every call to action on public marketing pages — one{" "}
            <code>gold</code> per band, <code>ghost-hairline</code> beside it.
          </li>
          <li>
            <code>sm</code> in the header; <code>lg</code> in heroes, bands and
            the mobile drawer.
          </li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            In the admin or signed-in app — use the standard{" "}
            <code>primary</code> / <code>secondary</code> buttons there.
          </li>
          <li>Don't hand-roll gold gradients; use the variant.</li>
        </ul>
      }
      preview={
        <div className="space-y-6 bg-page p-6">
          <div className="flex flex-wrap items-center gap-4">
            <Button asChild variant="gold" size="lg">
              <Link href="#buttons-public">Request a Consultation</Link>
            </Button>
            <Button asChild variant="ghost-hairline" size="lg">
              <Link href="#buttons-public">View Our Wines</Link>
            </Button>
          </div>
          <div className="flex flex-wrap items-center gap-4">
            <Button variant="gold" size="sm">
              Request a Consultation
            </Button>
            <Button variant="ghost-hairline" size="sm">
              Our Wines
            </Button>
          </div>
        </div>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>
            <code>variant</code>: <code>gold</code> | <code>ghost-hairline</code>
          </li>
          <li>
            <code>size</code>: <code>sm</code> (11.5px, .14em, 12×24px; also
            the default) | <code>lg</code> (12px, .16em, 19×40px)
          </li>
        </ul>
      }
    />
  );
}
